import React from 'react'
import styles from '../../../CSS/main.css'
import classNames from 'classnames'

type Props = {
  readonly onClick?: () => void
  readonly showMore?: boolean
  readonly isCommentList?: boolean
}

const Row: React.FC<Props> = ({
  children,
  onClick,
  showMore,
  isCommentList,
}) => {
  return (
    <div
      className={classNames({
        [styles.Row]: true,
        [styles.ShowMore]: !!showMore,
        [styles.IsCommentList]: !!isCommentList,
      })}
      onClick={onClick}>
      {children}
    </div>
  )
}

export default Row
